import {
  ActionIcon,
  Anchor,
  Badge,
  Card,
  Center,
  Menu,
  Text,
  rem
} from '@mantine/core'
import {
  IconBox,
  IconDotsVertical,
  IconPencil,
  IconTrash
} from '@tabler/icons-react'
import { MouseEvent } from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router'
import { AnimatedCard } from '@/components/ui-shared/AnimatedCard/AnimatedCard'

type ApplicationCardProps = {
  appName: string
  appDetailsLink: string
  isMultiStage?: boolean
  showActions?: boolean
  showEdit?: boolean
  showDelete?: boolean
  onRename: () => void
  onDelete: () => void
}

export const ApplicationCard = ({
  appName,
  appDetailsLink,
  isMultiStage,
  showActions,
  showEdit,
  showDelete,
  onRename,
  onDelete
}: ApplicationCardProps) => {
  const handleRename = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    onRename()
  }

  const handleDelete = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    onDelete()
  }

  return (
    <Anchor component={Link} to={appDetailsLink} underline="never">
      <AnimatedCard h={200}>
        <Card.Section pos="relative" withBorder>
          <Center h={120} bg="gray.1">
            <IconBox size={36} color="var(--mantine-color-brand-secondary-6)" />
          </Center>

          {isMultiStage && (
            <Badge pos="absolute" top={8} right={8} color="blue" size="xs">
              <FormattedMessage id="apps.multiStage" />
            </Badge>
          )}
        </Card.Section>

        <Card.Section pos="relative" py="md" inheritPadding>
          <Text size="sm" fw="bold" ta="center" lineClamp={2}>
            {appName}
          </Text>

          {showActions && (
            <Menu position="bottom-start" width={200}>
              <Menu.Target>
                <ActionIcon
                  pos="absolute"
                  top={2}
                  right={2}
                  variant="subtle"
                  size="md"
                  radius="xl"
                  onClick={(event) => event.preventDefault()}
                >
                  <IconDotsVertical style={{ width: '80%', height: '80%' }} />
                </ActionIcon>
              </Menu.Target>

              <Menu.Dropdown>
                {showEdit && (
                  <Menu.Item
                    leftSection={
                      <IconPencil style={{ width: rem(14), height: rem(14) }} />
                    }
                    onClick={handleRename}
                  >
                    <FormattedMessage id="rename" />
                  </Menu.Item>
                )}

                {showDelete && (
                  <Menu.Item
                    color="red"
                    leftSection={
                      <IconTrash style={{ width: rem(14), height: rem(14) }} />
                    }
                    onClick={handleDelete}
                  >
                    <FormattedMessage id="delete" />
                  </Menu.Item>
                )}
              </Menu.Dropdown>
            </Menu>
          )}
        </Card.Section>
      </AnimatedCard>
    </Anchor>
  )
}
